module.exports = __webpack_public_path__ + "img/appAsset--pdf-ax.1886a5b3.svg";